module.exports = __webpack_public_path__ + "media/images/manage-offer/choose-agency-56ead06bb66e15650ae3c09565cd6471.jpg";